/**
 * Service to handle sending data to webhooks
 */
export interface WebhookData {
  name?: string
  email?: string
  phone?: string
  company?: string
  message?: string
  formType?: string
  // Wizard specific fields
  agentType?: string
  platform?: string
  teamSize?: string
  supportNeeded?: string
  notes?: string
}
/**
 * Interface for conversation data to be sent to the webhook
 */
export interface ConversationData {
  role: string
  content: string
  timestamp: string
  sessionId?: string
}
/**
 * Sends data to the Pabbly webhook
 */
export const sendWebhookData = async (data: WebhookData): Promise<boolean> => {
  try {
    const response = await fetch(
      'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTZhMDYzMzA0MzA1MjZmNTUzMTUxMzQi_pc',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          timestamp: new Date().toISOString(),
        }),
      },
    )
    if (!response.ok) {
      console.error('Webhook submission failed:', await response.text())
      return false
    }
    return true
  } catch (error) {
    console.error('Error sending webhook data:', error)
    return false
  }
}
/**
 * Sends conversation data to the Pabbly webhook for Google Sheets integration
 */
export const sendConversationData = async (
  data: ConversationData,
): Promise<boolean> => {
  try {
    const response = await fetch(
      'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTZhMDYzMzA0MzA1MjY0NTUzMzUxMzAi_pc',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
    )
    if (!response.ok) {
      console.error(
        'Conversation webhook submission failed:',
        await response.text(),
      )
      return false
    }
    return true
  } catch (error) {
    console.error('Error sending conversation webhook data:', error)
    return false
  }
}
